/**

 * Premium card-stack list + detail hero visuals.

 *

 * Revert everything: set `enabled` to false.

 * Revert lists only: set `cardStack` to false.

 * Revert detail pages only: set `detailHero` to false.

 *

 * Chat and contact are intentionally excluded.

 */

export const CONTENT_LIST_VISUAL = {

  enabled: true,

  cardStack: true,

  detailHero: true,

  modules: [

    'benefits',

    'sindikalist',

    'documents',

    'notices',

    'polls',

    'qna',

    'article',

    'gallery',

  ],

};



export function isPremiumVisualModule(moduleId) {

  return CONTENT_LIST_VISUAL.enabled && CONTENT_LIST_VISUAL.modules.includes(moduleId);

}



export function isDetailHeroEnabled(moduleId) {

  return isPremiumVisualModule(moduleId) && CONTENT_LIST_VISUAL.detailHero;

}



export function premiumListClassName(moduleId, baseClassName = 'platform-content-list') {

  if (!isPremiumVisualModule(moduleId) || !CONTENT_LIST_VISUAL.cardStack) {

    return baseClassName;

  }



  return `${baseClassName} platform-content-list--card-stack`.trim();

}



export function premiumDetailClassName(moduleId, baseClassName = 'platform-content-detail') {

  if (!isDetailHeroEnabled(moduleId)) {

    return baseClassName;

  }



  return `${baseClassName} platform-content-detail--hero`.trim();

}



export function showListNavigateHint(moduleId) {

  return isPremiumVisualModule(moduleId) && CONTENT_LIST_VISUAL.cardStack;

}



export const PREMIUM_MODULE_IDS = {

  BENEFITS: 'benefits',

  SINDIKALIST: 'sindikalist',

  DOCUMENTS: 'documents',

  NOTICES: 'notices',

  POLLS: 'polls',

  QNA: 'qna',

  ARTICLES: 'article',

  GALLERY: 'gallery',

};

